<template>
  <div class="loginall">
    <banner-top :text="titletext"></banner-top>
    <div class="loginFuc">
        <div :class="isPhoneSignUp?'active':''" @click="phoneSignUp()">手机注册</div>
        <div :class="!isPhoneSignUp?'active':''" @click="emailSignUp();">邮箱注册</div>
    </div>
    <el-form
      v-if="isPhoneSignUp"
      :model="phoneForm"
      :rules="rulesPhone"
      ref="phoneForm"
    >
        <el-form-item
          style="border-bottom: 1px solid #DFDFDF;"
          prop="phone"
        >
          <el-row>
            <el-col :span='5'>
                <img class="iconimg" src="../assets/icon2.png" alt="">
            </el-col>
            <el-col class="inputpass" :span='19'>
              <el-input
                v-model="phoneForm.phone"
                placeholder="请输入手机号码"
                maxlength="11"
                onkeyup="value=value.replace(/[^\d]/g,'')"
                clearable
              ></el-input>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item
          style="border-bottom: 1px solid #DFDFDF;"
          prop="code"
        >
          <el-row>
            <el-col :span='5'>
                <img class="iconimg" src="../assets/icon4.png" alt="">
            </el-col>
            <el-col class="inputpass" :span='13'>
              <el-input
                v-model="phoneForm.code"
                placeholder="请输入验证码"
                maxlength="6"
                onkeyup="value=value.replace(/[^\d]/g,'')"
                clearable
               ></el-input>
            </el-col>
            <el-col class="inputpass" :span='6'>
                <el-link @click="onCode" style="color:#ffb949; margin-bottom:5px">{{codeText1}}</el-link>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item
          style="border-bottom: 1px solid #DFDFDF;"
          prop="password"
        >
          <el-row>
            <el-col :span='5'>
                <img class="iconimg" src="../assets/icon3.png" alt="">
            </el-col>
            <el-col class="inputpass" :span='19'>
              <el-input
                v-model="phoneForm.password"
                type="password"
                placeholder="请输入密码"
                clearable
              ></el-input>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item
          style="border-bottom: 1px solid #DFDFDF;"
          prop="again"
        >
          <el-row>
            <el-col :span='5'>
                <img class="iconimg" src="../assets/icon3.png" alt="">
            </el-col>
            <el-col class="inputpass" :span='19'>
              <el-input
                v-model="phoneForm.again"
                type="password"
                placeholder="请再次输入密码"
                clearable
              ></el-input>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item>
          <el-row>
            <el-col :span='2'>
                <img v-if="!checkPhone" @click="checkPhone=!checkPhone" style="width:17px" src="../assets/icon6.png" alt="">
                <img v-if="checkPhone"  @click="checkPhone=!checkPhone" style="width:17px" src="../assets/icon7.png" alt="">
            </el-col>
            <el-col class="inputpass" :span='22'>
              <span>我已阅读并同意</span>
              <el-link style="color:#ffb949;">《用户协议》</el-link>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item>
          <el-button @click="signUp('phoneForm')">注册</el-button>
        </el-form-item>
    </el-form>
    <el-form
      v-else
      :model="emailForm"
      :rules="rulesEmail"
      key="emailForm"
      ref="emailForm"
    >
        <el-form-item
          style="border-bottom: 1px solid #DFDFDF;"
          prop="email"
        >
          <el-row>
            <el-col :span='5'>
                <img class="iconimg" src="../assets/icon5.png" alt="">
            </el-col>
            <el-col class="inputpass" :span='19'>
              <el-input
                v-model="emailForm.email"
                placeholder="请输入邮箱"
                clearable
              ></el-input>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item
          style="border-bottom: 1px solid #DFDFDF;"
          prop="codeEmail"
        >
          <el-row>
            <el-col :span='5'>
                <img class="iconimg" src="../assets/icon4.png" alt="">
            </el-col>
            <el-col class="inputpass" :span='13'>
              <el-input
                v-model="emailForm.codeEmail"
                placeholder="请输入验证码"
                maxlength="6"
                onkeyup="value=value.replace(/[^\d]/g,'')"
                clearable
              ></el-input>
            </el-col>
            <el-col class="inputpass" :span='6'>
                <el-link @click="onCode" style="color:#ffb949; margin-bottom:5px">{{codeText2}}</el-link>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item
          style="border-bottom: 1px solid #DFDFDF;"
          prop="passwordEmail"
        >
          <el-row>
            <el-col :span='5'>
                <img class="iconimg" src="../assets/icon3.png" alt="">
            </el-col>
            <el-col class="inputpass" :span='19'>
              <el-input
                v-model="emailForm.passwordEmail"
                type="password"
                placeholder="请输入密码"
                clearable
              ></el-input>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item
          style="border-bottom: 1px solid #DFDFDF;"
          prop="againEmail"
        >
          <el-row>
            <el-col :span='5'>
                <img class="iconimg" src="../assets/icon3.png" alt="">
            </el-col>
            <el-col class="inputpass" :span='19'>
              <el-input
                v-model="emailForm.againEmail"
                type="password"
                placeholder="请再次输入密码"
                clearable
              ></el-input>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item>
          <el-row>
            <el-col :span='2'>
                <img v-if="!checkMail" @click="checkMail=!checkMail" style="width:17px" src="../assets/icon6.png" alt="">
                <img v-if="checkMail"  @click="checkMail=!checkMail" style="width:17px" src="../assets/icon7.png" alt="">
            </el-col>
            <el-col class="inputpass" :span='22'>
              <span>我已阅读并同意</span>
              <el-link style="color:#ffb949;">《用户协议》</el-link>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item>
          <el-button @click="signUp('emailForm')">注册</el-button>
        </el-form-item>
      </el-form>
    <div class="backLogin">
        <span><router-link to="/">返回登录</router-link></span>
    </div>
  </div>
</template>

<script>
import bannerTop from '../components/BannerTop.vue'
import http from '../utils/http'

export default {
  name: 'register',
  components: { bannerTop },
  data () {
    return {
      isPhoneSignUp: true,
      checkPhone: false,
      checkMail: false,
      titletext: '注册',
      phoneForm: {
        phone: '',
        code: '',
        password: '',
        again: ''
      },
      emailForm: {
        email: '',
        codeEmail: '',
        passwordEmail: '',
        againEmail: ''
      },
      codeText1: '获取验证码',
      codeText2: '获取验证码',
      myTime1: null,
      myTime2: null,
      rulesPhone: {
        phone: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { len: 11, message: '请输入11位手机号码', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { len: 6, message: '请输入6位数字验证码', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, message: '密码至少输入6位', trigger: 'blur' }
        ],
        again: [
          { required: true, message: '请再次输入密码', trigger: 'blur' },
          { min: 6, message: '密码至少输入6位', trigger: 'blur' }
        ]
      },
      rulesEmail: {
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱', trigger: 'blur' }
        ],
        codeEmail: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { len: 6, message: '请输入6位数字验证码', trigger: 'blur' }
        ],
        passwordEmail: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, message: '密码至少输入6位', trigger: 'blur' }
        ],
        againEmail: [
          { required: true, message: '请再次输入密码', trigger: 'blur' },
          { min: 6, message: '密码至少输入6位', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    signUp (formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          return
        }
        this.doSignUp()
      })
    },
    doSignUp () {
      if (this.isPhoneSignUp) {
        if (this.phoneForm.password !== this.phoneForm.again) {
          this.$message.error('两次密码输入不一致')
          return
        }
        if (!this.checkPhone) {
          this.$message.error('请勾选用户协议')
          return
        }
        // 手机号注册
        http['post']('auth/signup/phone', {
          phone: this.phoneForm.phone,
          code: this.phoneForm.code,
          password: this.phoneForm.password
        }).then((res) => {
          this.$message.success('注册成功!')
          localStorage.setItem('token', res.token)
          this.$router.push({name: 'IndexPage'})
        }).catch((err) => {
          this.$message.error(err)
        })
      } else {
        if (this.emailForm.passwordEmail !== this.emailForm.againEmail) {
          this.$message.error('两次密码输入不一致')
          return
        }
        if (!this.checkMail) {
          this.$message.error('请勾选用户协议')
          return
        }
        // 邮箱注册接口
        http['post']('auth/signup/email', {
          email: this.emailForm.email,
          code: this.emailForm.codeEmail,
          password: this.emailForm.passwordEmail
        }).then((res) => {
          this.$message.success('注册成功!')
          localStorage.setItem('token', res.token)
          this.$router.push({name: 'IndexPage'})
        }).catch((err) => {
          this.$message.error(err)
        })
      }
    },
    onCode () {
      if (this.isPhoneSignUp) {
        this.$refs['phoneForm'].validateField('phone', (errorMessage) => {
          if (errorMessage) {
            return
          }
          const data = {
            phone: this.phoneForm.phone,
            type: 'signup'
          }
          http['post']('auth/request_code/phone', data).then(async () => {
            await this.setTime(60 * 1000)
          }).catch((err) => {
            this.$message.error(err)
          })
        })
      } else {
        this.$refs['emailForm'].validateField('email', (errorMessage) => {
          if (errorMessage) {
            return
          }
          const data = {
            email: this.emailForm.email,
            type: 'signup'
          }
          http['post']('auth/request_code/email', data).then(async () => {
            await this.setTime(60 * 1000)
          }).catch((err) => {
            this.$message.error(err)
          })
        })
      }
    },
    setTime (time) {
      return new Promise((resolve, reject) => {
        if (this.isPhoneSignUp) {
          if (this.myTime1) return
          this.codeText1 = time / 1000 + '秒'
          this.myTime1 = setInterval(() => {
            time = time - 1000
            this.codeText1 = time / 1000 + '秒'
            if (time < 0) {
              clearInterval(this.myTime1)
              this.myTime1 = null
              this.codeText1 = '获取验证码'
              resolve()
            }
          }, 1000)
        } else {
          if (this.myTime2) return
          this.codeText2 = time / 1000 + '秒'
          this.myTime2 = setInterval(() => {
            time = time - 1000
            this.codeText2 = time / 1000 + '秒'
            if (time < 0) {
              clearInterval(this.myTime2)
              this.myTime2 = null
              this.codeText2 = '获取验证码'
              resolve()
            }
          }, 1000)
        }
      })
    },
    phoneSignUp () {
      this.$refs.emailForm.clearValidate()
      this.isPhoneSignUp = true
    },
    emailSignUp () {
      this.$refs.phoneForm.clearValidate()
      this.isPhoneSignUp = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.loginall {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.loginFuc {
    margin-bottom: 60px;
    display: flex;
    justify-content: center;
}
.loginFuc div {
    padding: 1rem 2.4rem;
    font-family: "PingFang-SC-Medium";
    font-size: 18px;
    color: #666;
}
.active {
    color: #ffb949!important;
    border-bottom: 2px solid #ffb949;
}
.loginPassword {
    display: flex;
    justify-content: center;
    width: 70%;
    border-bottom: 1px solid #e6e6e6;
}
.inputpass>>>.el-input__inner {
  border: 0;
}
.iconimg {
    width: 30px;
    height: 30px;
    margin-left: 10px;
}
.loginall button {
    width: 18rem;
    height: 3.5rem;
    background: #ffb949;
    border-radius: 44px;
    border: 0;
    margin-bottom: 1rem;
    color: #fff;
    font-size: 18px;
}
.backLogin {
    color:#666;
    margin-bottom: 3rem;
}
</style>



// WEBPACK FOOTER //
// src/login/register.vue